import { parseLocalDate } from "../../utils/programProgress";

const shortDate = (value: string, withYear = false): string => {
  const date = parseLocalDate(value);
  if (!date) return value;
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    ...(withYear ? { year: "numeric" } : {}),
  });
};

/** "13 Apr – 10 May" (year appended when the range crosses one). */
export const formatProgramDateRange = (
  startDate: string,
  endDate: string,
): string => {
  const start = parseLocalDate(startDate);
  const end = parseLocalDate(endDate);
  const crossesYear =
    start && end && start.getFullYear() !== end.getFullYear();
  return `${shortDate(startDate, Boolean(crossesYear))} – ${shortDate(
    endDate,
    Boolean(crossesYear),
  )}`;
};

export const formatWeeks = (durationWeeks: number): string =>
  `${durationWeeks} week${durationWeeks === 1 ? "" : "s"}`;

/** "Mon 13 Apr" for a day row. */
export const formatDayLabel = (value: string): string => {
  const date = parseLocalDate(value);
  if (!date) return value;
  return date.toLocaleDateString("en-GB", {
    weekday: "short",
    day: "numeric",
    month: "short",
  });
};
